<div *ngFor="let accessory of accessories; let i = index;">
  <app-featured-accessory *ngIf="accessory" (changes)="onChanges($event)" [index]="i" [accessory]="accessories[i]">
  </app-featured-accessory>
</div>